<!-- DOM order is the RTL reading order: واریز leads on the visual right. The caption
	under each tile is the button's own name, so it is hidden from assistive tech rather
	than read twice. -->
<nav class="flex items-center justify-center gap-6 rounded-2xl bg-gray-000 py-3" aria-label="عملیات کیف پول">
	@for (action of actions; track action.key) {
		<div class="flex flex-col items-center gap-1">
			<ui-button
				variant="mute"
				iconOnly
				extraButtonClasses="!size-14 !rounded-2xl"
				[label]="action.label"
				[attr.data-cy]="'wallet-action-' + action.key"
				(clicked)="actionRequested.emit(action.key)">
				@switch (action.icon.kind) {
					@case ('icon') {
						<ui-icon
							width="24"
							height="24"
							aria-hidden="true"
							[class]="action.icon.className"
							[iconName]="action.icon.name" />
					}
					@case ('image') {
						<!-- 21×21 artwork centred in the 24px icon slot, as the handoff draws it. -->
						<span class="flex size-6 items-center justify-center" aria-hidden="true">
							<img width="21" height="21" alt="" [ngSrc]="action.icon.src" />
						</span>
					}
				}
			</ui-button>
			<span class="text-2.75 font-medium text-gray-800" aria-hidden="true">{{ action.label }}</span>
		</div>
	}
</nav>
